<template>
    <b-container fluid class="py-3">
        <b-row>
            <b-col class="my-3">
                <strong>Total Amount Due : </strong><span><i> &#8377 </i>21412</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <Tableview v-model:value="items" :paginator="true" class="p-datatable-gridlines" :rows="10"
                    :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                    :columns="headers" dataKey="ID" :selectionMode=false>
                </Tableview>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <Button label="Confirm Payment" class="ms-2 p-button-info p-button-sm Footer float-end" />
            </b-col>
        </b-row>
    </b-container>

</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { useRouter } from "vue-router";

export default defineComponent({
    components: {
        Tableview
    },

    setup() {
        //Declaration
        const router = useRouter();
        // const items = ref([]);
        let items = ref([
            {
                SupplierId: '1',
            },
            {
                SupplierId: '2',
            }
        ])
        const loading = ref(false);
        //DataTable Fields
        const headers = [
            {
                header: "Invoice",
                field: "Invoice",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: 'filterdisplaynone',
                bodyclass: 'boldclass',
            },
            {
                header: "Payment Method",
                field: "PaymentMethod",
                class: 'filterdisplaynone',
                slot: "paymentmethod",
                fieldDisplay: "false",
            },
            {
                header: "Bank Details",
                field: "BankDetails",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                slot: "bankdetails",
                fieldDisplay: "false",
            }
        ];




        return {
            items,
            loading,
            headers,
        }
    }

})
</script>

<style lang="scss" scoped></style>